var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    id: "Capa_1",
    width: "800px",
    height: "800px",
    viewBox: "0 0 796.2 796.201",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.709,562.066c-26.248,0-47.501,21.264-47.501,47.504c0,26.238,21.253,47.502,47.501,47.502    c26.225,0,47.506-21.264,47.506-47.502C276.215,583.33,254.934,562.066,228.709,562.066z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.073,567.707c-26.225,0-47.504,21.269-47.504,47.505c0,26.235,21.279,47.503,47.504,47.503    c26.249,0,47.503-21.268,47.503-47.503C401.576,588.973,380.322,567.707,354.073,567.707z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.721,562.066c-26.234,0-47.5,21.264-47.5,47.504c0,26.238,21.266,47.502,47.5,47.502    c26.24,0,47.506-21.264,47.506-47.502C717.227,583.33,695.961,562.066,669.721,562.066z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.013,400.06c0-21.713-10.651-40.797-26.87-52.787c-10.906-8.064-24.297-12.998-38.916-12.998H605.943v12.998h-1.104    v166.076h-25.302h-27.485H126.426v82.501h27.493c6.456-35.471,37.445-62.372,74.79-62.372h125.364    c37.349,0,68.333,26.901,74.792,62.372H594.93c6.456-35.471,37.456-62.372,74.789-62.372c37.338,0,68.338,26.901,74.795,62.372    H796.2v-82.501h-13.188L783.013,400.06L783.013,400.06z M754.414,465.054h-84.693v-105.67h47.506c0,0,37.188,3.288,37.188,32.992    L754.414,465.054L754.414,465.054z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "566.872,488.016 592.174,488.016 592.174,321.939 592.174,133.486 0,133.486 0,488.016 113.762,488.016     539.385,488.016   ",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.390c0fdf969bed10f872cd28a0091aea.svg";
export { ForwardRef as ReactComponent };